import * as React from 'react';
import { defineMessages } from 'react-intl';
import { groupFeedbackWordMapping } from '../../Utils';
import { intl } from 'i18n';

const messages = defineMessages({
    label: {
        id: 'GroupFeedbackItem.lable',
        defaultMessage: 'Group fail feedback'
    },
    placeholder: {
        id: 'GroupFeedbackItem.placeholder',
        defaultMessage: 'Enter group feedback'
    },
    note: {
        id: 'GroupFeedbackItem.note',
        defaultMessage: 'Show this when the following options are selected:'
    },
    btn: {
        id: 'GroupFeedbackItem.btn',
        defaultMessage: 'Delete group feedback'
    },
});

export default class GroupFeedbackItem extends React.Component<any, any> {
    feedbackChangeHandler(event: any) {
        this.props.groupFeedbackChange({
            feedback: event.target.value,
            answers: this.props.answers,
            id: this.props.id
        })
    }

    private groupChangeHandler(event: any) {
        let answers = [];
        const id = event.target.dataset.answerId;
        if (event.target.checked && !this.props.answers.includes(id)) {
            answers = this.props.answers.concat(id);
        } else {
            answers = this.props.answers.filter((x: string) => x !== id);
        }
        this.props.groupFeedbackChange({
            feedback: this.props.feedback,
            answers: answers,
            id: this.props.id
        });
    }

    delete() {
        this.props.groupFeedbackRemove(this.props.id);
    }

    render() {
        return (
            <fieldset className='lxc-advanced-settings-feedback-wrapper'>
                <label className='lxc-advanced-settings-label' htmlFor={`feedbackField${this.props.id}`}>
                    {intl.formatMessage(messages.label)}
                </label>
                <textarea
                    rows={1}
                    id={`feedbackField${this.props.id}`}
                    className='lxc-advanced-settings-field'
                    placeholder={intl.formatMessage(messages.placeholder)}
                    value={this.props.feedback}
                    onChange={this.feedbackChangeHandler.bind(this)}>
                </textarea>
                <div className='lxc-advanced-settings-note'>
                    {intl.formatMessage(messages.note)}
                </div>
                <fieldset className='lxc-fieldset-wrap'>
                    <legend className='lxc-sr'>
                        {intl.formatMessage(messages.note)}
                    </legend>
                    <div className='lxc-advanced-settings-feedback-options'>
                        {
                            this.props.answersList.map((el: any, i: number) => {
                                return (
                                    <div key={i} className='lxc-advanced-settings-feedback-option'>
                                        <input
                                            name='feedback-option'
                                            type='checkbox'
                                            id={`feedback-option-${this.props.id}-${el.id}`}
                                            data-answer-id={el.id}
                                            checked={this.props.answers.indexOf(el.id) > -1}
                                            onChange={this.groupChangeHandler.bind(this)}
                                        />
                                        <label htmlFor={`feedback-option-${this.props.id}-${el.id}`} className='lxc-advanced-settings-feedback-label'>
                                            <span className='lxc-switch-checkbox'></span>
                                            {groupFeedbackWordMapping[i]}
                                        </label>
                                    </div>
                                )
                            })
                        }
                    </div>
                </fieldset>
                <button className='lxc-feedback-remove-btn' onClick={this.delete.bind(this)}>
                    {intl.formatMessage(messages.btn)}
                </button>
            </fieldset>
        )
    }
}
